import React from "react";
import {
  PanelBody,
  PanelRow,
  BaseControl,
  TextControl,
  Button,
  ExternalLink,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";

import useSettings from "../utils/useSettings";
const integrations = () => {
  const [getOption, updateOption, status] = useSettings();
  const [googleMapsAPI, setGoogleMapsAPI] = useState("");
  const [mailchimpAPI, setMailchimpAPI] = useState("");
  const [mailchimpAudienceID, setMailchimpAudienceID] = useState("");
  const [weatherAPI, setWeatherAPI] = useState("");

  useEffect(() => {
    setGoogleMapsAPI(getOption("ultrablocks_google_maps_api_key"));
    setWeatherAPI(getOption("ultrablocks_open_weather_map_api_key"));
    setMailchimpAPI(getOption("ultrablocks_mailchimp_api_key"));
    setMailchimpAudienceID(getOption("ultrablocks_mailchimp_audience_id"));
  }, [
    getOption("ultrablocks_google_maps_api_key"),
    getOption("ultrablocks_mailchimp_api_key"),
    getOption("ultrablocks_mailchimp_audience_id"),
    getOption("ultrablocks_open_weather_map_api_key"),
  ]);

  return (
    <>
      <PanelBody title={__("Google Maps", "ultrablocks")}>
        <PanelRow>
          <BaseControl
            label={__("Google Maps API", "ultrablocks")}
            help={__(
              "In order to use Google Maps block, you need to use Google Maps and Places API.",
              "ultrablocks"
            )}
            id="ultrablocks-options-google-map-api"
            className="ultrablocks-button-field"
          >
            <TextControl
              type="text"
              label={__("Secret Key", "ultrablocks")}
              value={googleMapsAPI}
              placeholder={__("Google Maps API Key", "ultrablocks")}
              disabled={"saving" === status}
              onChange={(value) => setGoogleMapsAPI(value)}
            />

            <div className="ultrablocks-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                disabled={"saving" === status}
                onClick={() =>
                  updateOption("ultrablocks_google_maps_api_key", googleMapsAPI)
                }
              >
                {__("Save", "ultrablocks")}
              </Button>

              <ExternalLink href="https://developers.google.com/maps/documentation/javascript/get-api-key">
                {__("Get API Key", "ultrablocks")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
      <PanelBody
        title={__("Weather API (Coming Soon...)", "ultrablocks")}
        initialOpen={true}
      >
        <PanelRow>
          <BaseControl
            label={__("Weather API", "ultrablocks")}
            help={__(
              "In order to use Weather block, you need to use Weather API.",
              "ultrablocks"
            )}
            id="ultrablocks-options-weather-api"
            className="ultrablocks-button-field"
          >
            <TextControl
              type="text"
              label={__("Secret Key", "ultrablocks")}
              value={weatherAPI}
              placeholder={__("Weather API Key", "ultrablocks")}
              disabled={true}
              onChange={(value) => setWeatherAPI(value)}
            />

            <div className="ultrablocks-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                disabled={true}
                onClick={() =>
                  updateOption(
                    "ultrablocks_open_weather_map_api_key",
                    weatherAPI
                  )
                }
              >
                {__("Save", "ultrablocks")}
              </Button>

              <ExternalLink href="https://home.openweathermap.org/api_keys">
                {__("Get API Key", "ultrablocks")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
      <PanelBody title={__("Mailchimp (NEWSLETTER)", "ultrablocks")} initialOpen={false}>
        <PanelRow>
          <BaseControl
            label={__("Mailchimp API", "ultrablocks")}
            help={__(
              "In order to use Newsletter block, you need to use Mailchimp API.",
              "ultrablocks"
            )}
            id="ultrablocks-options-mailchimp-api"
            className="ultrablocks-button-field"
          >
            <TextControl
              type="text"
              label={__("API Key", "ultrablocks")}
              value={mailchimpAPI}
              placeholder={__("Mailchimp API Key", "ultrablocks")}
              onChange={(value) => setMailchimpAPI(value)}
            />

            <TextControl
              type="text"
              label={__("AUDIENCE ID", "ultrablocks")}
              value={mailchimpAudienceID}
              placeholder={__("Mailchimp Audience ID", "ultrablocks")}
              onChange={(value) => setMailchimpAudienceID(value)}
            />

            <div className="ultrablocks-button-group">
              <Button
                variant="secondary"
                className="ubs-action-button"
                isSecondary
                onClick={() => {
                  updateOption("ultrablocks_mailchimp_api_key", mailchimpAPI);
                  updateOption(
                    "ultrablocks_mailchimp_audience_id",
                    mailchimpAudienceID
                  );
                }}
              >
                {__("Save", "ultrablocks")}
              </Button>

              <ExternalLink href="https://mailchimp.com/">
                {__("Get API Key", "ultrablocks")}
              </ExternalLink>
            </div>
          </BaseControl>
        </PanelRow>
      </PanelBody>
    </>
  );
};

export default integrations;
